// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"a1c68977","232":"3da90266","337":"a98437c4","387":"73ffd2c8","476":"785ad58d","597":"1d9b9f06","635":"68838a2a","703":"f60cc0ea","706":"9d869f17","738":"047bed2a","882":"83a1af83","993":"2149ad9d"}[chunkId] + ".chunk.js";
};